import { ISeat, IRacket } from '@/pages/Cart/types';
import { ITotalCartItems } from '@/redux/cart/types';
import { isItemExpired, getItemStartTime } from './cartHelpers';

const COURT_EXPIRATION_MINUTES = 11;
const RACKET_EXPIRATION_MINUTES = 15;

export function filterExpiredRackets(
  rackets: { [key: string]: IRacket },
  validCourts: { [key: string]: ISeat }
): { [key: string]: IRacket } {
  const validRackets: { [key: string]: IRacket } = {};

  Object.keys(rackets).forEach((key) => {
    const racket = rackets[key] as IRacket;

    if (racket.courtId && racket.courtTitle) {
      const courtExists = Object.values(validCourts).some(
        (seat: ISeat) =>
          seat.courtId === racket.courtId &&
          seat.date === racket.date &&
          seat.time === racket.time
      );

      if (courtExists) {
        const startTime = getItemStartTime(racket, 'rackets');
        if (!isItemExpired(startTime, RACKET_EXPIRATION_MINUTES)) {
          validRackets[key] = racket;
        }
      }
    } else {
      const startTime = getItemStartTime(racket, 'rackets');
      if (!isItemExpired(startTime, RACKET_EXPIRATION_MINUTES)) {
        validRackets[key] = racket;
      }
    }
  });

  return validRackets;
}

export function shouldDisableRacketToggle(cartItems: ITotalCartItems): boolean {
  const seats = cartItems.seats || {};
  return Object.keys(seats).length === 0;
}
